import React, { Suspense } from 'react';

import { QueryClientProvider } from '@tanstack/react-query';
import { di } from 'react-magnetic-di';

import { IsFhsEnabledProvider } from '@atlaskit/navigation-system/fhs-rollout';
import { queryClient } from '@atlassian/atlassian-studio-api';
import { getIdentityEnv } from '@atlassian/atlassian-studio-env-utils';
import { SentryErrorBoundary, setupSentryClient } from '@atlassian/atlassian-studio-observability';
import { PageMainContentLoadingLogo } from '@atlassian/atlassian-studio-ui-components';
import { EntryPointStatusAnnouncementProvider } from '@atlassian/entry-points/status-announcement-provider';
import { AtlassianRelayEnvironmentProvider } from '@atlassian/relay-environment-provider';

import { AppSelector } from './AppSelector';
import { WrappedAppSentryErrorFallback } from './WrappedAppSentryErrorFallback';

setupSentryClient({
	identityEnv: getIdentityEnv(),
	packageName: '@atlassian/studio-foundations',
});

export const WrappedApp = (): React.JSX.Element => {
	di(AppSelector, AtlassianRelayEnvironmentProvider);

	return (
		<AtlassianRelayEnvironmentProvider>
			<EntryPointStatusAnnouncementProvider>
				<Suspense
					fallback={<PageMainContentLoadingLogo interactionName="studio-foundations-wrapped-app" />}
				>
					<QueryClientProvider client={queryClient}>
						<SentryErrorBoundary
							fallbackComponent={WrappedAppSentryErrorFallback}
							loggerName="studio.foundations.wrapped-app"
							teamName="studio"
						>
							<IsFhsEnabledProvider value={false}>
								<AppSelector />
							</IsFhsEnabledProvider>
						</SentryErrorBoundary>
					</QueryClientProvider>
				</Suspense>
			</EntryPointStatusAnnouncementProvider>
		</AtlassianRelayEnvironmentProvider>
	);
};
